<template>
  <span
    :class="[
      'expandable-text',
      { 'expandable-text--single-line': singleLineCollapsed && isLong && !expanded },
    ]"
    role="button"
    tabindex="0"
    @click.stop.prevent="toggle"
    @keydown.enter.stop.prevent="toggle"
    @keydown.space.stop.prevent="toggle"
  >
    {{ displayText }}
  </span>
</template>

<script>
export default {
  name: 'ExpandableText',
  props: {
    text: {
      type: String,
      default: null,
    },
    maxLength: {
      type: Number,
      default: 120,
    },
    singleLineCollapsed: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      expanded: false,
    };
  },
  computed: {
    normalizedText () {
      return this.text ? String(this.text) : '';
    },
    isLong () {
      return this.normalizedText.length > this.maxLength;
    },
    displayText () {
      if (!this.normalizedText) return '—';
      if (!this.isLong) return this.normalizedText;
      if (this.expanded) return this.normalizedText;

      const trimmed = this.normalizedText.slice(0, this.maxLength).trimEnd();
      return `${trimmed}...`;
    },
  },
  watch: {
    text () {
      this.expanded = false;
    },
  },
  methods: {
    toggle () {
      if (!this.isLong) return;
      this.expanded = !this.expanded;
    },
  },
};
</script>

<style scoped>
.expandable-text {
  cursor: pointer;
  color: rgba(0, 0, 0, 0.72);
  word-break: break-word;
}

.expandable-text:hover,
.expandable-text:focus-visible {
  text-decoration: underline;
  text-underline-offset: 2px;
}

.expandable-text--single-line {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: bottom;
}
</style>
